class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true){
    const productForm = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      if(this.currentVariant != undefined){
        if(this.currentVariant.available){
          form.querySelector(".choose-cart").classList.remove('variant_sold-out');
        }else{
          form.querySelector(".choose-cart").classList.add('variant_sold-out');
        }
      }
      if (!addButton) return;
      if (!modifyClass) return;
    })
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown() {
  if (document.querySelector('.dropdown-wrap')) {
    document.querySelectorAll('.dropdown-wrap').forEach(function (dropdown) {
      dropdown.querySelector('.variant-dropdown').addEventListener('click', function (event) {
        event.preventDefault();
        dropdown.classList.toggle('active');

        dropdown.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.addEventListener('change', function (e) {
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = e.target.value;
          });
        });
      });
    });
  }
}

if(document.querySelectorAll('.product-addcart')) document.querySelectorAll('.product-addcart').forEach(function(button){
  button.addEventListener('click', function(evt) {
    evt.preventDefault();

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var cartform = button.closest('form'); // use the current button
    const formData = new FormData(cartform);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function() {
            document.querySelector('.product-form-error').innerHTML = '';
          }, 2000);
          return;
        } else {
          if (typeof load_cart == 'function') {
            cartNotification(response.id);
            load_cart();
            // setTimeout(function(){
            //   document.querySelector('body').classList.add('open-drawer');
            // },500);
          } else {
            window.location.href = "/cart";
          }
          const addedItem = response;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: Shopify.currency.active,
              value: addedItem.price / 100,
              items: [{
                item_id: addedItem.product_id,
                item_name: addedItem.product_title,
                item_category: addedItem.product_type,
                item_variant: addedItem.variant_title,
                item_variant_id: addedItem.variant_id,
                price: addedItem.price / 100,
                quantity: 1
              }]
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function product_slider(){
  // let main_thumb = new Swiper(".media-slider .media-thumb", {
  //   loop: false,
  //   spaceBetween: 0,
  //   slidesPerView: 'auto',
  //   direction: 'vertical',
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });
  let main_thumbs = []; // store all swiper instances
  document.querySelectorAll('.media-slider .media-thumb').forEach((thumbEl, i) => {
    const swiper = new Swiper(thumbEl, {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      direction: 'vertical',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      resizeObserver: false,
      navigation: {
        nextEl: thumbEl.querySelector(".swiper-button-next"),
        prevEl: thumbEl.querySelector(".swiper-button-prev"),
      },
    });
    main_thumbs.push(swiper);
  });
  function handleMediaScroll(scrollContainer) {
    let scrollDistance = (scrollContainer === window) ? window.scrollY : scrollContainer.scrollTop;

    if (window.innerWidth >= 992) {
      let wraps = (scrollContainer === window) 
        ? document.querySelectorAll('.product_media_wrap') 
        : [scrollContainer];

      wraps.forEach(function (product_media_wrap) {
        let columns = Array.from(product_media_wrap.querySelectorAll('.media-grid-column')).reverse();
        for (let element of columns) {
          const offset = window.innerHeight * 0.8;
          let elementTop = element.getBoundingClientRect().top + scrollDistance;
          let headerOffset = document.querySelector('.section-header')?.offsetHeight || 0;
          let height = elementTop - headerOffset;

          if (height <= scrollDistance + offset) {
            let dataIndex = element.getAttribute('data-index');
            let targetThumb = product_media_wrap.querySelector('.media-thumb-inr[data-index="' + dataIndex + '"]');
            if (targetThumb) {
              let swiperContainer = targetThumb.closest('.media-thumb');
              let swiperInstance = main_thumbs.find(s => s.el === swiperContainer);
              if (swiperInstance) {
                let thumbIndex = [...targetThumb.parentElement.children].indexOf(targetThumb);
                swiperInstance.slideTo(thumbIndex, 0);
                product_media_wrap.querySelectorAll('.media-grid-column').forEach(s => s.classList.remove('active-main-media'));
                product_media_wrap.querySelectorAll('.media-thumb-inr').forEach(s => s.classList.remove('swiper-slide-active'));
                element.classList.add('active-main-media');
                targetThumb.classList.add('swiper-slide-active');
              }
            }
            break;
          }
        }
      });
    }
  }

  // Keep the original page scroll listener for body scroll
  window.addEventListener('scroll', () => handleMediaScroll(window));

  function smoothScrollTo(start, end, duration){
    const distance = end - start;
    const startTime = performance.now();
    function scrollAnimation(currentTime){
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeInOutQuad(progress);
      window.scrollTo(0, start + distance * ease);
      if(progress < 1) requestAnimationFrame(scrollAnimation);
    }
    requestAnimationFrame(scrollAnimation);
  }
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
  document.querySelectorAll('.product_media_wrap').forEach(function(product_media_wrap){
    product_media_wrap.querySelectorAll('.media-thumb-inr').forEach(function(slide, index){
      slide.addEventListener('click', function(){
        let swiperContainer = slide.closest('.media-thumb');
        let swiperInstance = main_thumbs.find(s => s.el === swiperContainer);
        if (swiperInstance) {
          swiperInstance.slideTo(index, 0);
        }
        setTimeout(() => {
          product_media_wrap.querySelectorAll('.media-thumb-inr').forEach(s => s.classList.remove('swiper-slide-active'));
          slide.classList.add('swiper-slide-active');
        }, 100);

        let dataIndex = this.getAttribute('data-index');
        let targetElement = product_media_wrap.querySelector('.media-grid-column[data-index="' + dataIndex + '"]');
        if(targetElement){
          smoothScrollTo(window.scrollY, targetElement.offsetTop, 600);
        }
      });
    });
  });

  var init = false;
  var main_products = []; // store multiple swiper instances

  function productMobile() {
    if (window.innerWidth <= 991) {
      if (!init) {
        init = true;

        document.querySelectorAll('.inner-media .media-nav').forEach((navEl) => {
          let productWrap = navEl.closest('.product-wrap');
          if (!productWrap) return; // Skip if product-wrap is not found
          
          let countDiv = productWrap.querySelector('.product-media-count');
          
          const swiper = new Swiper(navEl, {
            loop: false,
            spaceBetween: 0,
            a11y: false,
            slidesPerView: "auto",
            resizeObserver: false,
            navigation: {
              nextEl: productWrap.querySelector(".swiper-button-next"),
              prevEl: productWrap.querySelector(".swiper-button-prev"),
            },
            pagination: {
              el: productWrap.querySelector(".main-mb-pagination .swiper-pagination"),
            },
            on: {
              init: function () {
                updateCounter(this, countDiv);
              },
              slideChange: function () {
                updateCounter(this, countDiv);
              }
            }
          });

          main_products.push(swiper);
        });

        function updateCounter(instance, countDiv) {
          if (!countDiv) return;
          let totalSlides = instance.slides.length;
          let currentIndex = instance.realIndex + 1;
          countDiv.textContent = `${currentIndex}/${totalSlides}`;
        }

      }
    } else if (init) {
      // Destroy all instances when going to desktop
      main_products.forEach(swiper => swiper.destroy(true, true));
      main_products = [];
      init = false;
    }
  }
  productMobile();
  window.addEventListener("resize", productMobile);



  if (document.querySelectorAll('.inner-media .media-grid-column')) {
    document.querySelectorAll('.inner-media .media-grid-column').forEach((inr_mb_media) => {
      inr_mb_media.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.innerWidth <= 991) {
          const targetIndex = parseInt(inr_mb_media.getAttribute('data-index'));
          document.body.setAttribute('data-zoom-index', targetIndex);
          inr_mb_media.closest('.media-slider').querySelector('.pdp-media-zoom-inr').click();
        }
      });
    });
  }

  if (document.querySelectorAll('.pdp-media-zoom-inr')) {
    document.querySelectorAll('.pdp-media-zoom-inr').forEach((zoomBtn) => {
      zoomBtn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('body').classList.add('open-zoom');
        
        const popupWrap = document.querySelector('.open-zoom .snippet-product-media-zoom');
        if (popupWrap) {
          popupWrap.addEventListener('scroll', () => handleMediaScroll(popupWrap));
        }

        let zoom_count = popupWrap.querySelector('.media-zoom-count');
        let main_thumb = new Swiper(".snippet-product-media-zoom .media-nav", {
          loop: false,
          spaceBetween: 0,
          slidesPerView: 'auto',
          resizeObserver: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            init: function () {
              updateZoomCounter(this, zoom_count);
            },
            slideChange: function () {
              updateZoomCounter(this, zoom_count);
              const activeZoom = document.querySelector('.goOnZoom.zoom-active');
              if (activeZoom) {
                activeZoom.style.backgroundSize = '';
                activeZoom.style.backgroundPosition = '';
                activeZoom.classList.remove('zoom-active');
              }

              // --- Mobile Pinch Zoom Reset ---
              const pinchElements = document.querySelectorAll('.goOnZoom');
              pinchElements.forEach(el => {
                el.style.backgroundSize = '';
                el.style.backgroundPosition = '';
              });

              // Reset pinchState
              pinchState.scale = 1;
              pinchState.translateX = 0;
              pinchState.translateY = 0;
              pinchState.isPanning = false;
              pinchState.element = null;
              

              let activeIndex = this.activeIndex;
              document.querySelectorAll('.media-zoom-thumb-inr').forEach(slide => {
                slide.classList.toggle('active-zoom-thumb', slide.dataset.index == activeIndex);
              });
              document.querySelector('.snippet-product-media-zoom').scrollTo({ top: 0, behavior: 'auto' });
            }
          }
        });

        function updateZoomCounter(instance, zoom_count) {
          if (!zoom_count) return;
          let totalSlides = document.querySelectorAll(".snippet-product-media-zoom .media-zoom-thumb-inr").length;
          let currentIndex = instance.realIndex + 1;
          zoom_count.textContent = `${currentIndex}/${totalSlides}`;
        }
        const selectedIndex = document.body.getAttribute('data-zoom-index');
        if (selectedIndex !== null) {
          main_thumb.slideTo(parseInt(selectedIndex), 0);
          document.body.removeAttribute('data-zoom-index');
        } else {
          main_thumb.slideTo(parseInt(document.querySelector('.media-grid-column.active-main-media').getAttribute('data-index')) - 1,0);
        }
        document.querySelectorAll('.media-zoom-thumb-inr').forEach(function (slide, index) {
          slide.addEventListener('click', function () {
            main_thumb.slideTo(index, 0);
            setTimeout(() => {
              document.querySelectorAll('.media-zoom-thumb-inr').forEach(s => s.classList.remove('active-zoom-thumb'));
              slide.classList.add('active-zoom-thumb');
            }, 100);
          });
        });
      });
    });
  }
  if(document.querySelectorAll('.zoom-close-left a,.zoom-close-right a')) document.querySelectorAll('.zoom-close-left a,.zoom-close-right a').forEach(function(zoom_close){
    zoom_close.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-zoom');
      document.querySelector('body').classList.add('do-not-open-menu');
      // setTimeout(() => {
        
      // }, 1000);
    });
  })
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}


if(document.querySelectorAll('.template-product:not(:has(.product-outfit-products)) .snippet-sticky-product-cart a')) document.querySelectorAll('.template-product:not(:has(.product-outfit-products)) .snippet-sticky-product-cart a').forEach(function(stickyCartLink) {
  stickyCartLink.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.innerWidth < 992) {
      if (stickyCartLink.classList.contains('one-size')) {
        document.querySelector('.product-addcart')?.click();
      } else {
        const target = document.querySelector('#product-form-installment') || document.querySelector('.product-outfit-products');
        if (!target) return;
        const targetY = target.getBoundingClientRect().bottom  + window.scrollY + 62 - window.innerHeight;
        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      }
    }
  });
});

// const stickyCartLink = document.querySelector('.template-product:not(:has(.product-outfit-products)) .snippet-sticky-product-cart a');
// if (stickyCartLink) {
//   stickyCartLink.addEventListener('click', function (e) {
//     e.preventDefault();
//     if(window.innerWidth < 992){
//       const announce = document.querySelector('.shopify-section-announcement-bar');
//       const header = document.querySelector('.shopify-section-header');
//       if (!header) return;
//       const target = document.querySelector('#product-form-installment') || document.querySelector('.product-outfit-products');
//       if (!target) return;
//       const offset = header.offsetHeight + 10 + (announce ? announce.offsetHeight : 0);
//       const targetY = target.getBoundingClientRect().top + window.scrollY - offset;
//       window.scrollTo({
//         top: targetY,
//         behavior: 'smooth'
//       });
//     }
//   });
// }
function checkStickyBar(){
  const installment = document.querySelector('#product-form-installment');
  const outfit = document.querySelector('.product-outfit-products');
  const reference = installment ? document.querySelector('.snippet-addto-cart') : document.querySelector('.prod-outfit-btn');
  const target = installment || outfit;
  if (!target || !reference) return;
  const targetRect = target.getBoundingClientRect();
  const condition = targetRect.height + reference.offsetHeight + 12 + targetRect.top - window.innerHeight < 0;
  if (condition) {
    document.body.classList.remove('stickybar');
  } else {
    document.body.classList.add('stickybar');
  }
}
window.addEventListener('scroll', checkStickyBar);
window.addEventListener('load', checkStickyBar);
if(document.querySelector('.color-remian')) document.querySelector('.color-remian').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('.color-remian').classList.toggle('show_all');
  document.querySelectorAll('.grid-meta-color li.hide_colors').forEach((hideColor) => {
    hideColor.classList.toggle('show_colors');
  })
})
document.querySelectorAll('.grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = color.querySelector('a').getAttribute('data-val');
    }
  })
  color.addEventListener('mouseout',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = document.querySelector('.grid-meta-color a').getAttribute('data-val');
    }
  })
})
window.addEventListener('scroll', function(){
  var scrollDistance = window.scrollY;
  if(window.innerWidth <= 991){
    if(document.querySelector('body:has(.product-outfit-products)')){
      if(document.querySelector('.product-outfit-products.outfit-anim')){
        if(scrollDistance > 0){
          document.body.classList.add('scroll-start');
        }else{
          document.body.classList.remove('scroll-start');
        }
      }
    }else{
      if(scrollDistance > 0){
        document.body.classList.add('scroll-start');
      }else{
        document.body.classList.remove('scroll-start');
      }
    }
    let announce = document.querySelector('.shopify-section-announcement-bar');
    let header = document.querySelector('.shopify-section-header');
    if(announce){
      if(scrollDistance >= (document.querySelector('.product-info').offsetTop - (header.offsetHeight + announce.offsetHeight))){
        document.body.classList.add('product-solid-header');
      }else{
        document.body.classList.remove('product-solid-header');
      }
    }else{
      if(scrollDistance >= (document.querySelector('.product-info').offsetTop - header)){
        document.body.classList.add('product-solid-header');
      }else{
        document.body.classList.remove('product-solid-header');
      }
    }
  }
});
if(document.querySelectorAll('.pam-accordion-inr')) document.querySelectorAll('.pam-accordion-inr').forEach(item => {
  let acc_cont = item.querySelector('.pam-acco-cont');
  acc_cont.style.maxHeight = '0';
  item.querySelector('.pam-acco-head').addEventListener('click', (e) => {
    e.preventDefault();
    let isOpen = item.classList.contains('active');
    document.querySelectorAll('.pam-accordion-inr').forEach(otherItem => {
      if(otherItem !== item){
        let otherContent = otherItem.querySelector('.pam-acco-cont');
        otherItem.classList.remove('active');
        otherContent.style.maxHeight = '0';
      }
    });
    if(!isOpen){
      item.classList.add('active');
      acc_cont.style.maxHeight = `${acc_cont.querySelector('.pam-acco-cont-inr').offsetHeight}px`;
    }else{
      item.classList.remove('active');
      acc_cont.style.maxHeight = '0';
    }
  });
  if(item.classList.contains('active')){
    acc_cont.style.maxHeight = `${acc_cont.querySelector('.pam-acco-cont-inr').offsetHeight}px`;
  }
});

if(document.querySelectorAll('.product-size-guide a')) document.querySelectorAll('.product-size-guide a').forEach(size_guide => {
  size_guide.addEventListener('click', function(e){
    e.preventDefault();
    let popupWrap = document.querySelector('.size-chart-popup-wrap');
    let sizeChart;
    if(size_guide.closest('.product-info').querySelector('.outfit-products-popup')){
      sizeChart = size_guide.closest('.product-info').querySelector('.opp-list-inr.outfit-active .size-chart-popup');
    }else{
      sizeChart = size_guide.closest('.product-info').querySelector('.size-chart-popup');
    }
    if(popupWrap && sizeChart){
      popupWrap.appendChild(sizeChart.cloneNode(true));
      // Reinitialize functionality for the cloned content
      initializeSizeChartFunctionality();
    }
    setTimeout(() => {
      document.querySelector('body').classList.add('open-size-chart');
    }, 200);
    if(document.querySelectorAll('.sc-close')) document.querySelectorAll('.sc-close').forEach(size_guide_close => {
      size_guide_close.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.size-chart-popup-wrap').innerHTML = '';
        document.querySelector('body').classList.remove('open-size-chart');
      });
    });
  });
});

// Function to initialize size chart functionality
function initializeSizeChartFunctionality() {
  // Initialize toggle buttons for size charts
  const toggleButtons = document.querySelectorAll('.size-chart-toggle');
  const chartContents = document.querySelectorAll('.chart-content');
  
  if (toggleButtons.length > 0 && chartContents.length > 0) {
    toggleButtons.forEach(button => {
      // Remove existing listeners to avoid duplicates
      button.replaceWith(button.cloneNode(true));
    });
    
    // Re-add event listeners
    document.querySelectorAll('.size-chart-toggle').forEach(button => {
      button.addEventListener('click', function() {
        const targetChart = this.dataset.chart;
        
        // Update active state on buttons
        document.querySelectorAll('.size-chart-toggle').forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Show/hide chart content
        document.querySelectorAll('.chart-content').forEach(content => {
          if (content.dataset.chart === targetChart) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        });
      });
    });
  }
  
  // Initialize hover effects for table cells
  document.querySelectorAll('.size-chart td, .size-chart th').forEach((cell) => {
    // Remove existing listeners to avoid duplicates
    cell.replaceWith(cell.cloneNode(true));
  });
  
  document.querySelectorAll('.size-chart td, .size-chart th').forEach((cell) => {
    cell.addEventListener('mouseenter', function () {
      let columnIndex = cell.cellIndex;
      let table = cell.closest('.size-chart');
      if (table) {
        table.querySelectorAll('tr').forEach(row => {
          if (row.cells[columnIndex]) {
            row.cells[columnIndex].classList.add('hovered');
          }
        });
      }
    });
    
    cell.addEventListener('mouseleave', function () {
      let columnIndex = cell.cellIndex;
      let table = cell.closest('.size-chart');
      if (table) {
        table.querySelectorAll('tr').forEach(row => {
          if (row.cells[columnIndex]) {
            row.cells[columnIndex].classList.remove('hovered');
          }
        });
      }
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeSizeChartFunctionality();
});

// if(document.querySelectorAll('.product-size-guide a')) document.querySelectorAll('.product-size-guide a').forEach(size_guide => {
//   size_guide.addEventListener('click', function(e){
//     e.preventDefault();
//     console.log('close');
//     let popupWrap = document.querySelector('.size-chart-popup-wrap');
//     let sizeChart;
//     if(size_guide.closest('.product-info').querySelector('.outfit-products-popup')){
//       console.log('iff');
//       sizeChart = size_guide.closest('.product-info').querySelector('.opp-list-inr.outfit-active .size-chart-popup');
//     }else{
//       console.log('else');
//       sizeChart = size_guide.closest('.product-info').querySelector('.size-chart-popup');
//     }
//     if(popupWrap && sizeChart){
//       popupWrap.appendChild(sizeChart.cloneNode(true));
//     }
//     setTimeout(() => {
//       document.querySelector('body').classList.add('open-size-chart');
//     }, 200);
//     if(document.querySelectorAll('.sc-close')) document.querySelectorAll('.sc-close').forEach(size_guide_close => {
//       size_guide_close.addEventListener('click', function(e){
//         e.preventDefault();
//         document.querySelector('.size-chart-popup-wrap').innerHTML = '';
//         document.querySelector('body').classList.remove('open-size-chart');
//       });
//     });
//   });
// });
// if(document.querySelectorAll('.size-chart td')) document.querySelectorAll('.size-chart td').forEach((cell, index) => {
//   cell.addEventListener('mouseenter', function () {
//     let columnIndex = cell.cellIndex;
//     document.querySelectorAll('.size-chart tr').forEach(row => {
//       if (row.cells[columnIndex]) {
//         row.cells[columnIndex].classList.add('hovered');
//       }
//     });
//   });
//   cell.addEventListener('mouseleave', function () {
//     let columnIndex = cell.cellIndex;
//     document.querySelectorAll('.size-chart tr').forEach(row => {
//       if (row.cells[columnIndex]) {
//         row.cells[columnIndex].classList.remove('hovered');
//       }
//     });
//   });
// });

if (document.querySelectorAll('.prod-outfit-btn a,.template-product:has(.product-outfit-products) .snippet-sticky-product-cart a')) {
  document.querySelectorAll('.prod-outfit-btn a,.template-product:has(.product-outfit-products) .snippet-sticky-product-cart a').forEach((mb_outfit_btn) => {
    mb_outfit_btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.innerWidth >= 992 && window.scrollY !== 0){
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const onScroll = () => {
          if(window.scrollY === 0){
            document.querySelector('.shopify-section-header').classList.remove('sticky_header');
            openOutfitPopup();
            window.removeEventListener('scroll', onScroll);
          }
        };
        window.addEventListener('scroll', onScroll);
      }else{
        openOutfitPopup();
      }
    });
  });
}

// ----------------------------------- Zoom -------------------------------------

let pinchState = {
  scale: 1,
  startScale: 1,
  startDist: 0,
  startX: 0,
  startY: 0,
  translateX: 0,
  translateY: 0,
  isPanning: false,
  element: null
};
const desktopZoomConfig = {
  initialZoom: 2,   // starting zoom level when activated
  minZoom: 1.25,    // minimum zoom
  maxZoom: 4,       // maximum zoom
  zoomSpeed: 0.01   // speed of scroll zoom
};
// document.querySelectorAll('.goOnZoom').forEach(el => {
//   // Mobile pinch zoom
//   el.addEventListener('touchstart', handleTouchStart, { passive: false });
//   el.addEventListener('touchmove', handleTouchMove, { passive: false });
//   el.addEventListener('touchend', handleTouchEnd, { passive: false });

//   // Desktop click-to-zoom
//   el.addEventListener('click', function (e) {
//     if (window.innerWidth <= 768) return; // Only for desktop
//     e.preventDefault();
//     toggleDesktopZoom(el, e);
//   });

class DesktopZoom {
  constructor(element, config) {
    this.element = element;
    this.config = { ...desktopZoomConfig, ...config };
    this.zoomed = false;
    this.zoom = this.config.initialZoom;

    this._bindEvents();
  }

  _bindEvents() {
    this.element.addEventListener("mousemove", (e) => this._onMouseMove(e));
    this.element.addEventListener("mouseleave", () => this._onMouseLeave());
  }

  activate() {
    this.zoomed = true;
    this.element.classList.add("zoom-active");
    this.element.style.backgroundSize = `${this.zoom * 100}%`;
  }

  deactivate() {
    this.zoomed = false;
    this.element.classList.remove("zoom-active");
    this.element.style.backgroundSize = '';
    this.element.style.backgroundPosition = '';
  }

  _onMouseMove(e) {
    if (!this.zoomed) return;
    const rect = this.element.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    this.element.style.backgroundPosition = `${x}% ${y}%`;
  }

  _onMouseLeave() {
    if (this.zoomed) this.deactivate();
  }
}

// Map each element to its zoom instance
const desktopZoomInstances = new WeakMap();

function toggleDesktopZoom(element) {
  if (!desktopZoomInstances.has(element)) {
    desktopZoomInstances.set(element, new DesktopZoom(element));
  }
  const instance = desktopZoomInstances.get(element);
  if (instance.zoomed) {
    instance.deactivate();
  } else {
    instance.activate();
  }
}
// Desktop click-to-zoom toggle
// function toggleDesktopZoom(element, e){
//   const isZoomed = element.classList.toggle('zoom-active');
//   if (isZoomed) {
//     element.style.backgroundSize = '200%'; // zoomed
//     element.addEventListener('mousemove', moveZoom);
//   } else {
//     element.removeEventListener('mousemove', moveZoom);
//     element.style.backgroundSize = ''; // reset
//     element.style.backgroundPosition = '';
//   }
// }

// function moveZoom(e) {
//   const zoomer = e.currentTarget;
//   const rect = zoomer.getBoundingClientRect();
//   const x = ((e.pageX - rect.left) / rect.width) * 100;
//   const y = ((e.pageY - rect.top) / rect.height) * 100;
//   zoomer.style.backgroundPosition = `${x}% ${y}%`;
// }

// Mobile pinch functions
function getDistance(touches) {
  const [a, b] = touches;
  return Math.sqrt((b.pageX - a.pageX) ** 2 + (b.pageY - a.pageY) ** 2);
}

function getMidpoint(touches) {
  const [a, b] = touches;
  return { x: (a.pageX + b.pageX) / 2, y: (a.pageY + b.pageY) / 2 };
}

function handleTouchStart(e) {
  if (e.touches.length === 2) {
    e.preventDefault();
    pinchState.element = e.currentTarget;
    pinchState.startDist = getDistance(e.touches);
    pinchState.startScale = pinchState.scale;
    pinchState.midpoint = getMidpoint(e.touches);
  } else if (e.touches.length === 1 && pinchState.scale > 1) {
    pinchState.isPanning = true;
    pinchState.startX = e.touches[0].pageX - pinchState.translateX;
    pinchState.startY = e.touches[0].pageY - pinchState.translateY;
  }
}

function handleTouchMove(e) {
  if (!pinchState.element) return;

  if (e.touches.length === 2) {
    e.preventDefault();
    const newDist = getDistance(e.touches);
    const zoomFactor = newDist / pinchState.startDist;
    pinchState.scale = Math.min(Math.max(1, pinchState.startScale * zoomFactor), 3); // 1–3x
    applyTransform();
  }

  if (e.touches.length === 1 && pinchState.isPanning) {
    e.preventDefault();
    pinchState.translateX = e.touches[0].pageX - pinchState.startX;
    pinchState.translateY = e.touches[0].pageY - pinchState.startY;
    applyTransform();
  }
}

function handleTouchEnd(e) {
  if (e.touches.length === 0) {
    pinchState.isPanning = false;
    if (pinchState.scale <= 1) {
      pinchState.scale = 1;
      pinchState.translateX = 0;
      pinchState.translateY = 0;
      applyTransform();
    }
  }
}

function applyTransform() {
  if (!pinchState.element) return;

  const container = pinchState.element.getBoundingClientRect();
  const baseSize = 150;
  const zoomedSize = baseSize * pinchState.scale;

  const extraWidth = (zoomedSize - baseSize) / 100 * container.width;
  const extraHeight = (zoomedSize - baseSize) / 100 * container.height;

  const maxX = extraWidth / 2;
  const maxY = extraHeight / 2;

  pinchState.translateX = Math.max(Math.min(pinchState.translateX, maxX), -maxX);
  pinchState.translateY = Math.max(Math.min(pinchState.translateY, maxY), -maxY);

  pinchState.element.style.backgroundSize = `${zoomedSize}%`;
  pinchState.element.style.backgroundPosition =
    `calc(50% + ${pinchState.translateX}px) calc(50% + ${pinchState.translateY}px)`;
}

// function applyTransform() {
//   if (!pinchState.element) return;
//   pinchState.element.style.backgroundSize = `${150 * pinchState.scale}%`;
//   pinchState.element.style.backgroundPosition = `calc(50% + ${pinchState.translateX}px) calc(50% + ${pinchState.translateY}px)`;
// }
// ---------------------------- Zoom ------------------------------
function openOutfitPopup(){
  document.body.classList.add('open-outfit');
  document.querySelector('.opp-list-inr').classList.add('outfit-active');
  document.querySelector('.opp-count').textContent = '1';
  document.querySelector('.opp-progress').style.width = 100 / document.querySelectorAll('.opp-list-inr').length + '%';
}
// if(document.querySelector('.prod-outfit-btn a')) document.querySelector('.prod-outfit-btn a').addEventListener('click', function(e){
//   e.preventDefault();
//   document.body.classList.add('open-outfit');
//   document.querySelector('.opp-list-inr').classList.add('outfit-active');
//   document.querySelector('.opp-count').textContent = '1';
//   document.querySelector('.opp-progress').style.width = 100 / document.querySelectorAll('.opp-list-inr').length + '%';
// });
if(document.querySelectorAll('.opp-popup-close,.outfit-products-popup-overly,.outfit-success-close')) document.querySelectorAll('.opp-popup-close,.outfit-products-popup-overly,.outfit-success-close').forEach((opp_popup_close) => {
  opp_popup_close.addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('open-outfit');
    document.querySelector('.opp-count').textContent = '1';
    document.querySelector('.opp-progress').style.width = 100 / document.querySelectorAll('.opp-list-inr').length + '%';
    document.querySelectorAll('.opp-list-inr').forEach((opp_skip) => {
      opp_skip.classList.remove('outfit-active','added');
    });
    document.querySelectorAll('.outfit-success-products li').forEach((opp_succ_prod) => {
      opp_succ_prod.classList.remove('active');
    });
    document.querySelector('.outfit-success').classList.remove('outfit-active');
    // let all_added = false;
    // document.querySelectorAll('.opp-list-inr').forEach((opp_list) => {
    //   if(opp_list.classList.contains('added')){
    //     all_added = true;
    //   }
    // });
    // if(all_added) document.querySelector('.snippet-product-outfit-products').classList.add('all_added');
  });
});
if(document.querySelectorAll('.opp-skip')) document.querySelectorAll('.opp-skip').forEach((opp_skip) => {
  opp_skip.addEventListener('click',function(e){
    e.preventDefault();
    opp_skip.closest('.opp-list-inr').classList.remove('outfit-active');
    if(opp_skip.closest('.opp-list-inr').nextElementSibling.classList.contains('outfit-success')){
      let has_added = true;
      document.querySelectorAll('.opp-list-inr').forEach((list) => {
        if(list.classList.contains('added')){
          document.querySelector('.outfit-success').classList.add('outfit-active');
          has_added = false;
          document.querySelector('.opp-count').textContent = '1';
          document.querySelector('.opp-progress').style.width = 100 / document.querySelectorAll('.opp-list-inr').length + '%';
        }
      });
      if(has_added){
        document.body.classList.remove('open-outfit');
      }
      let all_added = 0;
      document.querySelectorAll('.opp-list-inr').forEach((opp_list) => {
        if(opp_list.classList.contains('added')){
          all_added++;
        }
      });
      document.querySelector('.outfit-added-count').textContent = all_added;
      // if(all_added == document.querySelectorAll('.opp-list-inr').length) document.querySelector('.snippet-product-outfit-products').classList.add('all_added');
      // if(document.querySelector('.snippet-product-outfit-products').classList.contains('all_added')){
      //   opp_skip.closest('.opp-list-inr').nextElementSibling.classList.add('outfit-active');
      // }else{
      //   document.body.classList.remove('open-outfit');
      // }
    }else{
      opp_skip.closest('.opp-list-inr').nextElementSibling.classList.add('outfit-active');
    }
    if(document.querySelector('.opp-list-inr.outfit-active')){
      let count = 100 / document.querySelectorAll('.opp-list-inr').length;
      document.querySelector('.opp-progress').style.width = (count * parseInt(document.querySelector('.opp-list-inr.outfit-active').getAttribute('data-index'))) + '%';
      document.querySelector('.opp-count').textContent = document.querySelector('.opp-list-inr.outfit-active').getAttribute('data-index');
    }

  });
});
if(document.querySelectorAll('.outfit-variants li')) document.querySelectorAll('.outfit-variants li').forEach((outfit_variants) => {
  outfit_variants.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelectorAll('.outfit-variants li').forEach((outfit_variants_rm) => {
      outfit_variants_rm.classList.remove('active-variant');
    });
    outfit_variants.classList.add('active-variant');
  });
});
if(document.querySelectorAll('.outfit-add-btn')) document.querySelectorAll('.outfit-add-btn').forEach(function(outfit_add){
  outfit_add.addEventListener('click',function(e){
    e.preventDefault();
    let variant_id = outfit_add.closest('.opp-list-variant').querySelector('.outfit-variants li.active-variant').dataset.id;
    let error_grid = outfit_add.closest('.opp-list-variant').querySelector('.outfit-variant-outer .grid-error');
    let formData = {
      'items': [{
        'id': variant_id,
        'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.status == 422){
        error_grid.innerHTML = data.description;
        setTimeout(function(e){
          error_grid.innerHTML = '';
        },2000);
      }else{          
        if(document.location.href.indexOf('/cart') > -1) {
          window.location.href = "/cart";
        }else{
          if(typeof load_cart == 'function'){
            // cartNotification(data.items[0].id);
            load_cart();
            outfit_add.closest('.opp-list-inr').classList.add('added');
            let index = outfit_add.closest('.opp-list-inr').getAttribute('data-index');
            console.log(index,'----',document.querySelector('.outfit-success-products li[data-index="'+ index +'"]'));
            document.querySelector('.outfit-success-products li[data-index="'+ index +'"]').classList.add('active');
            outfit_add.closest('.opp-list-inr').classList.remove('outfit-active');
            let count = 100 / document.querySelectorAll('.opp-list-inr').length;
            document.querySelector('.opp-progress').style.width = (count * parseInt(outfit_add.closest('.opp-list-inr').nextElementSibling.getAttribute('data-index'))) + '%';
            document.querySelector('.opp-count').textContent = outfit_add.closest('.opp-list-inr').nextElementSibling.getAttribute('data-index');
            if(outfit_add.closest('.opp-list-inr').nextElementSibling.classList.contains('outfit-success')){
              let all_added = 0;
              document.querySelectorAll('.opp-list-inr').forEach((opp_list) => {
                if(opp_list.classList.contains('added')){
                  all_added++;
                }
              });
              document.querySelector('.outfit-added-count').textContent = all_added;
              if(all_added == document.querySelectorAll('.opp-list-inr').length) document.querySelector('.snippet-product-outfit-products').classList.add('all_added');
              // if(document.querySelector('.snippet-product-outfit-products').classList.contains('all_added')){
              //   outfit_add.closest('.opp-list-inr').nextElementSibling.classList.add('outfit-active');
              // }else{
              //   document.body.classList.remove('open-outfit');
              // }
              let has_added = true;
              document.querySelectorAll('.opp-list-inr').forEach((list) => {
                if(list.classList.contains('added')){
                  document.querySelector('.outfit-success').classList.add('outfit-active');
                  has_added = false;
                }
              });
              if(has_added){
                document.body.classList.remove('open-outfit');
              }
            }else{
              outfit_add.closest('.opp-list-inr').nextElementSibling.classList.add('outfit-active');
            }
          }else{
            window.location.href = "/cart";
          }          
        }
        const url = '/cart.js';
        fetch(url)
        .then((resp) => resp.json())
        .then(function(data) {
          var cart_count = data.item_count;
          if(cart_count>0){
            document.querySelector('.cart-count').innerHTML = ' ['+ cart_count +']';
          }else{
            document.querySelector('.cart-count').innerHTML = '';
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        const addedItem = data.items[0];
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            currency: Shopify.currency.active,
            value: addedItem.price / 100,
            items: [{
              item_id: addedItem.product_id,
              item_name: addedItem.product_title,
              item_category: addedItem.product_type,
              item_variant: addedItem.variant_title,
              item_variant_id: addedItem.variant_id,
              price: addedItem.price / 100,
              quantity: 1
            }]
          }
        });
      }
    })
    .catch((error) => {
      console.error(error);
    });
  });
});
(() => {
  const trigger = document.querySelector('.prod-to-desc');
  const target = document.querySelector('#product-accordions-media');
  const header = document.querySelector('.shopify-section-header');
  if (!trigger || !target) return;
  let animation = null;
  let running = false;
  const getTargetY = () => {
    const rectTop = target.getBoundingClientRect().top;
    let offset = 0;
    if (window.innerWidth <= 991 && header) {
      offset += header.offsetHeight;
    } else {
      offset = 0;
    }
    return window.scrollY + rectTop - offset;
  };
  const stopScroll = () => {
    if (animation) cancelAnimationFrame(animation);
    animation = null;
    running = false;
    ['wheel', 'touchstart', 'keydown'].forEach(ev =>
      window.removeEventListener(ev, stopScroll, { passive: true })
    );
  };
  const smoothScroll = () => {
    running = true;
    ['wheel', 'touchstart', 'keydown'].forEach(ev =>
      window.addEventListener(ev, stopScroll, { passive: true })
    );
    const start = performance.now();
    const maxTime = 1600;
    const step = now => {
      const targetY = getTargetY();
      const currentY = window.scrollY;
      const delta = targetY - currentY;
      if (Math.abs(delta) > 1 && now - start < maxTime && running) {
        window.scrollTo(0, currentY + delta * 0.18);
        animation = requestAnimationFrame(step);
      } else {
        window.scrollTo(0, getTargetY());
        stopScroll();
      }
    };
    animation = requestAnimationFrame(step);
  };
  trigger.addEventListener('click', e => {
    e.preventDefault();
    stopScroll();
    smoothScroll();
  });
})();
// if(document.querySelector('.prod-to-desc')) document.querySelector('.prod-to-desc').addEventListener('click', function(e){
//   e.preventDefault();
//   let target = document.querySelector('#product-accordions-media');
//   if(target) target.scrollIntoView({ behavior: 'smooth', block: 'start'});
// });
const giftCheckbox = document.getElementById('send-as-gift');
const giftForm = document.querySelector('.main-gift-form');
if (giftCheckbox && giftForm) {
  giftCheckbox.addEventListener('change', function () {
    if (this.checked) {
      giftForm.classList.add('active');
    } else {
      giftForm.classList.remove('active');
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector('.product-outfit-products')){
    const container = document.querySelector('.product-outfit-products');
    const items = container.querySelectorAll('.prod-outfit-inr');
    let delay = 500;
    let index = 0;
    function fadeNext() {
      if(index < items.length){
        items[index].classList.add('fade-in');
        index++;
        setTimeout(fadeNext, delay);
      }else{
        container.classList.add('outfit-anim');
        document.body.classList.add('stickybar');
      }
    }
    fadeNext();
  }
});



